import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { mapLinkVariant, LINK_DISABLED_CLASSNAME } from "./constants.js";
import { sizeStyles, StyledIcon, colorStyles, commonLinkStyles, StyledLink, StyledAnchor } from "./styles.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
import cn from "../../vendor/classnames/index.js";
import { spreadSx } from "../../utils/spreadSx.js";
const Link = forwardRef(({ children, iconLeft, iconRight, size: size_, sx, ...props }, ref) => {
  const size = size_ || (iconLeft || iconRight ? "md" : void 0);
  return /* @__PURE__ */ jsxs(
    LinkText,
    {
      variant: size ? mapLinkVariant[size] : void 0,
      ref,
      sx: size ? [sizeStyles[size], ...spreadSx(sx)] : sx,
      ...props,
      children: [
        iconLeft && /* @__PURE__ */ jsx(StyledIcon, { size, children: iconLeft }),
        children,
        iconRight && /* @__PURE__ */ jsx(StyledIcon, { size, children: iconRight })
      ]
    }
  );
});
Link.displayName = "Link";
const LinkText = forwardRef(
  ({
    children,
    color = "primary",
    href,
    disabled,
    onClick,
    to,
    sx,
    className,
    variant: typography,
    ...props
  }, ref) => {
    const classNames = cn(disabled ? LINK_DISABLED_CLASSNAME : "", className), styles = useMemo(
      () => ({
        ...colorStyles[color],
        ...commonLinkStyles
      }),
      [color]
    ), sxProps = [{ typography }, styles, ...spreadSx(sx)];
    return to ? /* @__PURE__ */ jsx(
      StyledLink,
      {
        className: classNames,
        ref,
        "data-test-id": DATA_TEST_ID_INHERITED,
        sx: sxProps,
        to,
        ...props,
        children
      }
    ) : /* @__PURE__ */ jsx(
      StyledAnchor,
      {
        className: classNames,
        ref,
        "data-test-id": DATA_TEST_ID_INHERITED,
        sx: sxProps,
        href,
        onClick: (e) => {
          onClick && (e.preventDefault(), onClick(e));
        },
        ...props,
        children
      }
    );
  }
);
LinkText.displayName = "LinkText";
export {
  Link,
  LinkText
};
//# sourceMappingURL=Link.js.map
